import { StatsigProvider, useClientAsyncInit } from '@statsig/react-bindings';
import { match } from 'ts-pattern';
import { environment } from './lib/config';

export const FeatureFlagProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const statSigEnv = match(environment)
    .with('mainnet', () => 'production')
    .with('testnet', () => 'staging')
    .with('devnet', () => 'development')
    .with('development', () => 'development')
    .exhaustive();

  const { client } = useClientAsyncInit(
    'client-f3tB9ueMLOwVCzpVwuPsG0X5t6Wg8npXYsulqeIedwV',
    {},
    { environment: { tier: statSigEnv } }
  );
  return <StatsigProvider client={client}>{children}</StatsigProvider>;
};
